import { useRef, FunctionComponent, useState, useEffect } from "react";
import styles from "./AddOrganization.module.css";
import TextInput from "../../Components/TextInput/InputText";
import { autoFacebookCreateApi, createOrganization } from "../../Services/organizations";
import { emailValidate, nameValidate, pincodeValidate } from "../../Values/validatorsnew";
import Loading from "../../Components/Loading/Loading";
import {url } from "../../Values/constants";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import axios from "axios";
import { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { fetchLicensesCost } from "../../Services/resources";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import DropDownText from "../../Components/DropDownText/DropDownText";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import PhoneNumberWrapper from "../../Components/TextInput/PhoneNumberWrapper";

type props = {
  history: any;
  theme: any;
};

const AddOrganization: FunctionComponent<props> = ({ history, theme }) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const [load, setLoad] = useState(false);
  const [seletedState, setSeletedState] = useState<any>({ label: "Select", value: "Select" });
  const [industry, setIndustry] = useState<any>({ label: "Select", value: "Select" });
  const [booleanSendEmail, setBooleanSendEmail] = useState(false);
  const [pwd, setPwd] = useState("");
  const [industryList, setIndustryList] = useState<any>([]);
  const [countryList, setCountryList] = useState<any>([]);
  const [statesList, setStatesList] = useState<any>([]);
  const [citiesList, setCitiesList] = useState<any>([]);
  const [seletecCountry, setSelectedCountry] = useState<any>({ label: "Select", value: "Select" });
  const [orgId, setOrgId] = useState();
  const [authId, setAuthId] = useState();
  const [cost, setCost] = useState<any>("");
  const [noEmp, setNoEmp] = useState<any>("");
  const [costLicensesData, setCostLicensesData] = useState<any[] | undefined>(undefined);
  const [seletedCities, setSeletedCities] = useState<any>({ label: "Select", value: "Select" });
  const organizationNameRef: any = useRef();
  const emailRef: any = useRef();
  const addressRef: any = useRef();
  const pincodeRef: any = useRef();
  const adminFirstNameRef: any = useRef();
  const adminLastNameRef: any = useRef();
  const adminEmailRef: any = useRef();
  const employeesRef: any = useRef();
  const [phoneCountryCode, setPhoneCountryCode] = useState('in');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [finalPhoneNumber, setFinalPhoneNumber] = useState('');
  const [adminPhoneCountryCode, setAdminPhoneCountryCode] = useState('in');
  const [adminPhoneNumber, setAdminPhoneNumber] = useState('');
  const [adminFinalPhoneNumber, setAdminFinalPhoneNumber] = useState('');

  const handlePhoneChange = (value: string, country: CountryData) => {
  
    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalPhoneNumber(value);
    }
    setPhoneCountryCode(country?.dialCode);
    setPhoneNumber(value)
  };

  const handleAdminPhoneChange = (value: string, country: CountryData) => {
  
    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setAdminFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setAdminFinalPhoneNumber(value);
    }
    setAdminPhoneCountryCode(country?.dialCode);
    setAdminPhoneNumber(value)
  };
 
  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
  }, []);

  useEffect(() => {
    fetchLicensesCost((data) => setCostLicensesData(data));
  }, [])

  useEffect(() => {
    setCost(costLicensesData?.[0]?.licensesCost);
    setNoEmp(costLicensesData?.[0]?.no_employees);
  }, [costLicensesData]);

  const create = (e: any) => {
    e.preventDefault();
    if (organizationNameRef.current.value === "") {
      dispatcher(
        showSnackbarAction(
          "Organization Name Required!!",
          "error"
        )
      );
      return;
    }
    else if (finalPhoneNumber === "") {
      dispatcher(
        showSnackbarAction(
          "Mobile Number Required!!",
          "error"
        )
      );
      return;
    }
    else if (emailRef.current?.value === "") {
      dispatcher(
        showSnackbarAction(
          "Email Required!!",
          "error"
        )
      );
      return;
    }

    else if (addressRef.current.value === "") {
      dispatcher(
        showSnackbarAction(
          "Address Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(seletecCountry).length === 0) {
      dispatcher(
        showSnackbarAction(
          "Country Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(seletedState).length === 0) {
      dispatcher(
        showSnackbarAction(
          "State Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(seletedCities).length === 0) {
      dispatcher(
        showSnackbarAction(
          "City Required!!",
          "error"
        )
      );
      return;
    }
    else if (pincodeRef.current?.value === "") {
      dispatcher(
        showSnackbarAction(
          "Pincode Required!!",
          "error"
        )
      );
      return;
    }

    else if (adminFirstNameRef.current?.value === "") {
      dispatcher(
        showSnackbarAction(
          "Admin First Name Required!!",
          "error"
        )
      );
      return;
    }
    else if (adminLastNameRef.current?.value === "") {
      dispatcher(
        showSnackbarAction(
          "Admin First Last Required!!",
          "error"
        )
      );
      return;
    }
    else if (adminFinalPhoneNumber === "") {
      dispatcher(
        showSnackbarAction(
          "Mobile Number Required!!",
          "error"
        )
      );
      return;
    }
    else if (adminEmailRef.current?.value === "") {
      dispatcher(
        showSnackbarAction(
          "Admin Email Required!!",
          "error"
        )
      );
      return;
    }
    else if (employeesRef.current.value === "") {
      dispatcher(
        showSnackbarAction(
          "No of Employees Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(industry).length === 0) {
      dispatcher(
        showSnackbarAction(
          "Industry Id Required!!",
          "error"
        )
      );
      return;
    }

    setLoad(true);
    
    createOrganization(
      organizationNameRef.current?.value,
      finalPhoneNumber,
      phoneCountryCode == "in" ? 91 : parseInt(phoneCountryCode),
      emailRef.current?.value,
      addressRef.current?.value,
      (seletecCountry as any).label,
      (seletecCountry as any).value,
      (seletedState as any).label,
      (seletedState as any).value,
      (seletedCities as any).label,
      (seletedCities as any).value,
      pincodeRef.current?.value,
      adminFirstNameRef.current?.value,
      adminLastNameRef.current?.value,
      adminFinalPhoneNumber,
      adminPhoneCountryCode == "in" ? 91 : parseInt(adminPhoneCountryCode),
      adminEmailRef.current?.value,
      employeesRef.current?.value,
      history,
      dispatcher,
      window,
      (data: boolean) => setLoad(data),
      (data: boolean) => setBooleanSendEmail(data),
      (data: any) => setPwd(data),
      (industry as any).value,
      (data: any) => setOrgId(data),
      (data: any) => setAuthId(data),
      cost,
      noEmp
    );
  };

  useEffect(() => {
    if (booleanSendEmail) {
     
      sendResetPasswordEmail();
     
      createOrganizationDb();
      
      autoFacebookCreateApi(
        orgId,
        "Facebook",
        adminPhoneCountryCode == "in" ? "+91" : `+${adminPhoneCountryCode}`,
        adminEmailRef.current?.value?.toLowerCase(),
        adminPhoneCountryCode == "in" ? 91 : parseInt(adminPhoneCountryCode),
        adminFinalPhoneNumber,
        adminFirstNameRef.current?.value,
        adminLastNameRef.current?.value,
      );
    }
  }, [booleanSendEmail]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryRes = await axios.post(
          `${url}/country/countries`);
       
          // handle response
        setCountryList(countryRes.data);
      } catch (error) {
      
        // handle error
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    if (Object.keys(seletecCountry).length !== 0) {
      const fetchData = async () => {
        try {
          const statesRes = await axios.post(
            `${url}/country/states`, { iso3: (seletecCountry as any).value });
        
            // handle response
          setStatesList(statesRes.data);
        } catch (error) {
          
          // handle error
        }
      };
      fetchData();

    }
  }, [seletecCountry]);

  useEffect(() => {
    if (Object.keys(seletecCountry).length !== 0 && Object.keys(seletedState).length !== 0) {
      const fetchData = async () => {
        try {
          const citiesRes = await axios.post(
            `${url}/country/cities`, { iso3: (seletecCountry as any).value, state_code: (seletedState as any).value });
        
            // handle response
          setCitiesList(citiesRes.data);
        } catch (error) {
        
          // handle error
        }
      };
      fetchData();
    }
  }, [seletecCountry, seletedState])

  const createOrganizationDb = async () => {
    const bodyData = {
      organization_id: orgId,
      address: addressRef.current?.value,
      admin_contact_number: adminFinalPhoneNumber,
      admin_email_id: adminEmailRef.current?.value.toLowerCase(),
      admin_first_name: adminFirstNameRef.current?.value,
      admin_last_name: adminLastNameRef.current?.value,
      auth_id: authId,
      city: (seletedCities as any).label,
      country: (seletecCountry as any).label,
      created_at: "",
      designations: [],
      email_id: emailRef.current?.value.toLowerCase(),
      mobile_number: finalPhoneNumber,
      no_of_employees: employeesRef.current?.value,
      organization_name: organizationNameRef.current?.value,
      state: (seletedState as any).label,
      status: "ACTIVE",
      teams: [],
      industry_id: (industry as any).value,
      payment_status: true,
      grace_period: 7,
      showData: true,
      trial_period: true,
    }
    const createOrg = await axios.post(
      url + '/organizations/create', bodyData
    );
  }

  const sendResetPasswordEmail = async () => {
    let email = adminEmailRef.current?.value.toLowerCase()
    let firstName = adminFirstNameRef.current?.value;
    let lastName = adminLastNameRef.current?.value;
    if (email !== "") {
      try {
        if (email) {
          setLoad(true);
          const resetPasswordEmailApiData = {
            "template_name": "Password_Reset_Notification",
            "replaceable_params": [
              { "%#username#%": `${firstName} ${lastName}` },
              { "%#password#%": pwd }
            ],
            "email": email
          }
          await axios.post(
            url + '/email/sendEmail',
            resetPasswordEmailApiData
          );
          setLoad(false);
          dispatcher(
            showSnackbarAction(
              "Password reset information have been sent on you registered email id",
              "success"
            )
          );
          history.push("/");
        }
      } catch (error) {
        console.log("reset error", error);
      }
    } else {
      dispatcher(showSnackbarAction("Please Enter Your Email!", "error"));
    }
  }

  const choice = () => {
    let optionArr = statesList?.map((list: { state_code: any, name: any }) => ({
      value: list.state_code,
      label: list.name
    }));
    return optionArr;
  };

  const countryChoice = () => {
    let optionArr = countryList?.map((list: { iso3: any, name: any, phone_code: any }) => ({
      value: list.iso3,
      label: `${list.name}`
    }));
    return optionArr;
  };

  const citiesChoice = () => {
    let optionArr = citiesList?.map((list: { name: any }) => ({
      value: list.name,
      label: list.name
    }));
    return optionArr;
  };
  useEffect(() => {
    getIndustry();
  }, []);

  const getIndustry = async () => {
    const industryRes = await axios.post(
      url + '/headers/getAllIndustries',
      {
        "status": "Launched"
      }
    );
    setIndustryList(industryRes.data);
  }
  const choiceIndustry = () => {
    let optionArr = industryList?.map((list: { industry_id: any, industry_name: any }) => ({
      value: list.industry_id,
      label: list.industry_name
    }));
    return optionArr;
  }

  const noValidateEmp = (empNo: string) => {
    console.log("phone", Number(empNo));
    const re = /^[0-9]*$/;
    const valid = re.test(empNo);
    if (valid) {
      if (Number(empNo) > noEmp) {
        return `Trial period allows ${noEmp} licences.`
      }
      else {
        return "";
      }
    }
    else {
      return "Allow only Number.";
    }
  };

  const handleCountryChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = countryList.find((item: any) => item.iso3 === selectedValue);
    const selectedObj = obj
      ? { value: obj.iso3, label: obj.name }
      : { value: "Select", label: "Select" };
    setSelectedCountry(selectedObj);
  };

  const handleStateChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = statesList?.find((item: any) => item?.state_code === selectedValue);
    const selectedObj = obj
      ? { value: obj.state_code, label: obj.name }
      : { value: "Select", label: "Select" };
    setSeletedState(selectedObj);
  };

  const handleCitiesChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = citiesList?.find((item: any) => item?.name === selectedValue);
    const selectedObj = obj
      ? { value: obj.name, label: obj.name }
      : { value: "Select", label: "Select" };
    setSeletedCities(selectedObj);
  };

  const handleIndustryChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = industryList?.find((item: any) => item?.industry_id === selectedValue);
    const selectedObj = obj
      ? { value: obj.industry_id, label: obj.industry_name }
      : { value: "Select", label: "Select" };
    setIndustry(selectedObj);
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
    <>
      <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
        {load && <Loading />}
        {isMobile && (
          <div
            className="d-flex flex-row w-100 px-4 pt-4"
          >
            <h5
              style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}
            >
              Add Organization Details
            </h5>
          </div>
        )}
        <div
          className="w-100 d-flex flex-column gap-2 px-4"
          style={{
            padding: isMobile ? '0' : '',
            maxWidth: isMobile ? '100vw' : undefined,
            margin: isMobile ? '0' : '0 auto',
            overflowY: isMobile ? 'auto' : undefined,
            maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
          }}
        >
          <form
            className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
            style={{
              ...cardContainerStyles,
              padding: isMobile ? '16px' : '32px',
              boxSizing: 'border-box',
              minHeight: isMobile ? 'auto' : undefined,
              marginBottom: isMobile ? '50px' : 0,
            }}
          >
            <Grid container spacing={isMobile ? 2 : 3}>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="First Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={organizationNameRef}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <PhoneNumberWrapper
                  title="Mobile Number"
                  country={phoneCountryCode || 'in'}
                  value={phoneNumber}
                  handlePhoneChange={handlePhoneChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Email"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={emailRef}
                  validator={emailValidate}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Address"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={addressRef}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="Country"
                  options={countryChoice()}
                  value={seletecCountry.value === "Select" ? "" : seletecCountry.value}
                  onChange={handleCountryChange}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="State"
                  options={choice()}
                  value={seletedState.value === "Select" ? "" : seletedState.value}
                  onChange={handleStateChange}
                  required
                  labelKey="label"
                  valueKey="value"
                  disabled={seletecCountry.value === "Select" ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="City"
                  options={citiesChoice()}
                  value={seletedCities.value === "Select" ? "" : seletedCities.value}
                  onChange={handleCitiesChange}
                  required
                  labelKey="label"
                  valueKey="value"
                  disabled={seletedState.value === "Select" ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Pincode"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={pincodeRef}
                  validator={pincodeValidate}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Admin First Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={adminFirstNameRef}
                  validator={nameValidate}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Admin Last Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={adminLastNameRef}
                  validator={nameValidate}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <PhoneNumberWrapper
                  title="Admin Contact No"
                  country={adminPhoneCountryCode || 'in'}
                  value={adminPhoneNumber}
                  handlePhoneChange={handleAdminPhoneChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Admin Email Id"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={adminEmailRef}
                  validator={emailValidate}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Number of Employees"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={employeesRef}
                  validator={noValidateEmp}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="Industry Id"
                  options={choiceIndustry()}
                  value={industry.value === "Select" ? "" : industry.value}
                  onChange={handleIndustryChange}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
             
              {/* Remove submit button from inside form for mobile */}
              {!isMobile && (
                <Grid item xs={12} style={{ marginTop: 12 }}>
                  <StyledSubmitButton
                    onClick={(e) => create(e)}
                    themeMode={themeMUI.palette.mode}
                  >
                    {load ? (
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <Circles color="#fff" height={20} width={20} />
                      </span>
                    ) : (
                      <>Submit</>
                    )}
                  </StyledSubmitButton>
                </Grid>
              )}
            </Grid>
          </form>
        </div>
        {isMobile && (
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              bgcolor: "white",
              p: 2,
              borderTop: "1px solid #ddd",
              boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
              zIndex: 100,
            }}
          >
            <StyledSubmitButton
              onClick={(e) => create(e)}
              themeMode={themeMUI.palette.mode}
              isMobile={isMobile}
            >
              {load ? (
                <span style={{ display: "flex", justifyContent: "center" }}>
                  <Circles color="#fff" height={20} width={20} />
                </span>
              ) : (
                <>Submit</>
              )}
            </StyledSubmitButton>
          </Box>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(AddOrganization);
